import { Type } from "@sinclair/typebox";
import { IsoDateTimeSchema, OpaqueIdSchema, SubjectIdSchema } from "./primitives.js";
export const WorkspaceReadinessCheckKeys = [
    "tenant_owner",
    "workspace_profile",
    "provider_custodian",
    "dedicated_runner",
    "event_sink",
    "capability_policy",
    "approval_group",
    "budget_threshold",
    "artifact_retention",
    "object_store",
    "canary_probe",
];
const WorkspaceReadinessCheckStatusSchema = Type.Union([
    Type.Literal("incomplete"),
    Type.Literal("satisfied"),
    Type.Literal("blocked"),
]);
const WorkspaceReadinessCheckSourceSchema = Type.Union([
    Type.Literal("system"),
    Type.Literal("owner_configuration"),
]);
function readinessCheck(key) {
    return Type.Object({
        key: Type.Literal(key),
        status: WorkspaceReadinessCheckStatusSchema,
        source: WorkspaceReadinessCheckSourceSchema,
        detail: Type.String({ minLength: 1, maxLength: 1_000 }),
    }, { additionalProperties: false });
}
export const WorkspaceReadinessCheckSchema = Type.Object({
    key: Type.Union(WorkspaceReadinessCheckKeys.map((key) => Type.Literal(key))),
    status: WorkspaceReadinessCheckStatusSchema,
    source: WorkspaceReadinessCheckSourceSchema,
    detail: Type.String({ minLength: 1, maxLength: 1_000 }),
}, { additionalProperties: false });
const WorkspaceReadinessConfigurationProperties = {
    workspace_purpose: Type.String({ minLength: 1, maxLength: 1_000 }),
    data_classification: Type.Union([
        Type.Literal("internal"),
        Type.Literal("confidential"),
        Type.Literal("restricted"),
    ]),
    provider_custodian: Type.Object({
        subject_id: SubjectIdSchema,
        provider_label: Type.String({ minLength: 1, maxLength: 120 }),
        scope: Type.String({ minLength: 1, maxLength: 500 }),
        purpose: Type.String({ minLength: 1, maxLength: 500 }),
        expires_at: IsoDateTimeSchema,
        review_at: IsoDateTimeSchema,
    }, { additionalProperties: false }),
    budget_threshold: Type.Object({
        currency: Type.String({ pattern: "^[A-Z]{3}$" }),
        amount_minor: Type.Integer({ minimum: 1, maximum: Number.MAX_SAFE_INTEGER }),
        period: Type.Literal("monthly"),
    }, { additionalProperties: false }),
    artifact_retention_days: Type.Integer({ minimum: 1, maximum: 3_650 }),
};
export const WorkspaceReadinessConfigurationSchema = Type.Object(WorkspaceReadinessConfigurationProperties, { additionalProperties: false });
export const WorkspaceReadinessSchema = Type.Object({
    schema: Type.Literal("carbon.operations.workspace-readiness/v1"),
    tenant_id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    revision: Type.Integer({ minimum: 0 }),
    state: Type.Union([Type.Literal("incomplete"), Type.Literal("ready")]),
    execution_enabled: Type.Boolean(),
    configuration: Type.Optional(WorkspaceReadinessConfigurationSchema),
    checks: Type.Tuple([
        readinessCheck("tenant_owner"),
        readinessCheck("workspace_profile"),
        readinessCheck("provider_custodian"),
        readinessCheck("dedicated_runner"),
        readinessCheck("event_sink"),
        readinessCheck("capability_policy"),
        readinessCheck("approval_group"),
        readinessCheck("budget_threshold"),
        readinessCheck("artifact_retention"),
        readinessCheck("object_store"),
        readinessCheck("canary_probe"),
    ]),
}, { additionalProperties: false, $id: "carbon.operations.workspace-readiness/v1" });
export const WorkspaceReadinessConfigureSchema = Type.Object({
    schema: Type.Literal("carbon.operations.workspace-readiness.configure/v1"),
    expected_revision: Type.Integer({ minimum: 0 }),
    ...WorkspaceReadinessConfigurationProperties,
    confirmation: Type.Literal(true),
}, { additionalProperties: false, $id: "carbon.operations.workspace-readiness.configure/v1" });
//# sourceMappingURL=readiness.js.map